module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-pov-58562943908bf4ae9eadb772906fc975.png";